module.exports = __webpack_public_path__ + "img/not-verified.fa828029.svg";